// src/components/layout/LeaderSidebar.js - main menu of the leader area.
// Audit FL-34: NavLink active state also on sub-pages (/choreographies/12), sticky
// on desktop, labelled close button, help and contact in the footer (FL-38 wording:
// "Přehled", "Grand Finále").
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Award, CreditCard, Home, Mail, Music, Trophy, Users, X } from 'lucide-react';

export const LEADER_MENU = [
  { path: '/', icon: Home, label: 'Přehled', end: true },
  { path: '/dancers', icon: Users, label: 'Tanečníci' },
  { path: '/competitions', icon: Award, label: 'Soutěže' },
  { path: '/choreographies', icon: Music, label: 'Choreografie' },
  { path: '/qualified', icon: Trophy, label: 'Grand Finále' },
  { path: '/invoices', icon: CreditCard, label: 'Fakturace' },
];

const LeaderSidebar = ({ onClose }) => (
  <div className="flex h-full w-64 flex-col overflow-y-auto bg-white shadow-lg md:shadow-none md:border-r md:border-gray-200">
    {onClose && (
      <div className="flex items-center justify-between px-4 pt-4">
        <span className="text-base font-semibold text-gray-900">Menu</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Zavřít menu"
          className="rounded-md p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <X className="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
    )}

    <nav aria-label="Hlavní menu" className="flex-1 px-3 py-4">
      <ul className="space-y-1">
        {LEADER_MENU.map((item) => (
          <li key={item.path}>
            <NavLink
              to={item.path}
              end={item.end}
              onClick={onClose}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 ${
                  isActive ? 'bg-indigo-50 text-indigo-700' : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                }`
              }
            >
              <item.icon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>

    <div className="border-t border-gray-200 px-4 py-4 text-sm text-gray-600">
      <p className="font-medium text-gray-900">Nápověda a kontakt</p>
      <a
        href="mailto:info@bestofthebest.cz"
        className="mt-1 inline-flex items-center gap-1.5 text-indigo-700 hover:text-indigo-900"
      >
        <Mail className="h-4 w-4" aria-hidden="true" />
        info@bestofthebest.cz
      </a>
      <a
        href="https://www.bestofthebest.cz"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 block text-indigo-700 hover:text-indigo-900"
      >
        Web soutěže bestofthebest.cz
      </a>
    </div>
  </div>
);

export default LeaderSidebar;
